<template>
  <a-card class="auth__card" title="Логин">
    <a-form>
      <a-form-item label="Ваш email">
        <a-input
          v-model="params.email"
          type="email"
          placeholder="user@mail.com"
        ></a-input>
      </a-form-item>
      <a-form-item label="Ваш пароль">
        <a-input
          v-model="params.password"
          type="password"
          placeholder="********"
        ></a-input>
      </a-form-item>
      <a-form-item>
        <a-button
          @click.prevent="login"
          :loading="isLoading"
          class="button"
          block
          type="primary"
          html-type="submit"
          >Войти</a-button
        >
      </a-form-item>
      <p class="text-center">
        <router-link to="/auth/reset">Забыли пароль?</router-link>
      </p>
      <p class="text-center">
        У вас нет аккаунта?
        <router-link to="/auth/reg">Зарегистрируйтесь</router-link>
      </p>
    </a-form>
  </a-card>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      params: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      this.$api.login({ ...this.params })
        .then((response) => {
          this.$store.commit('setToken', response.data.access_token);
          this.$router.push('/');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>
